"use client";

import { useMemo } from "react";

import { useLomdaV3Editor } from "../store/useLomdaV3Editor";
import { buildMediaLibrary, type LomdaLibraryItem } from "../lib/mediaAssets";

const NO_ICONS: string[] = [];
const NO_DELETED: Record<string, string> = {};

export function useMediaLibrary(): LomdaLibraryItem[] {
    const content = useLomdaV3Editor((s) => s.content);
    const assets = useLomdaV3Editor((s) => s.assets);
    const icons =
        useLomdaV3Editor((s) => s.metadata.theme?.customIcons) ?? NO_ICONS;
    const deleted =
        useLomdaV3Editor((s) => s.metadata.deletedAssets) ?? NO_DELETED;
    return useMemo(
        () => buildMediaLibrary(content, assets, icons, deleted),
        [content, assets, icons, deleted]
    );
}
